import { useQuery } from '@tanstack/react-query';
import { collection, getDocsFromServer, orderBy, query } from 'firebase/firestore';
import { db } from '../firebase/config';

export const courseCollectionQueryKey = (collectionPath: string) => ['courses', collectionPath] as const;

// Course content is public and admin-managed, so a cached one-time read is
// enough. Navigating back to a path within 5 minutes makes no network call.
// getDocsFromServer (not getDocs): when offline, getDocs can resolve with an
// empty cached result, which would be kept for 5 minutes as "no courses".
// This fails instead, so React Query retries and the page can offer "Try again".
export const useCourseCollection = <T extends { id: string }>(collectionPath: string) => {
    const { data, isPending, error } = useQuery({
        queryKey: courseCollectionQueryKey(collectionPath),
        queryFn: async () => {
            const snapshot = await getDocsFromServer(query(collection(db, collectionPath), orderBy('order', 'asc')));
            return snapshot.docs.map(doc => ({ ...doc.data(), id: doc.id }) as T);
        },
    });

    return {
        documents: data ?? null,
        loading: isPending,
        error,
    };
};
